import { useContext, useMemo } from 'react';
import UFOInteractionContext from '../interaction-context';
import { getInteractionId } from '../interaction-id-context';
import { addCohortingCustomData } from '../interaction-metrics';
export default function UFOCustomCohortData({
  dataKey,
  value
}) {
  const interactionContext = useContext(UFOInteractionContext);
  useMemo(() => {
    if (!interactionContext) {
      return;
    }
    const interactionId = getInteractionId();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) {
      return;
    }
    addCohortingCustomData(currentInteractionId, dataKey, value);
  }, [dataKey, value, interactionContext]);
  return null;
}
export function addUFOCustomCohortData(key, value) {
  const interactionId = getInteractionId();
  const currentInteractionId = interactionId.current;
  if (!currentInteractionId) {
    return;
  }
  addCohortingCustomData(currentInteractionId, key, value);
}